
const digest = '576f04e21fe617b425b43b412f0d868fccb1ffaf30cf0b8c65267fcf51c15353';
const classes = {"wrapper":"_wrapper_b42fm_1","tableWrapper":"_tableWrapper_b42fm_10"};
const css = `._wrapper_b42fm_1 {
  display: flex;
  flex-direction: column;
  font-family: Rubik, "sans-serif";
  height: 100%;
  overflow: hidden;
  min-height: 0;
}

._tableWrapper_b42fm_10 {
  flex: 1;
  min-height: 0;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  